<template>
  <div class="app-container">
    <div class="filter-container">
      <el-input
        v-model="listQuery.phone"
        placeholder="手机号"
        style="width: 180px"
        class="filter-item"
        clearable
      />
      <el-select
        v-model="listQuery.is_payout"
        placeholder="收支类型"
        style="width: 120px"
        class="filter-item"
        clearable
      >
        <el-option label="支出" :value="1" />
        <el-option label="收入" :value="0" />
      </el-select>

      <el-select
        v-model="listQuery.type"
        placeholder="操作类型"
        style="width: 120px"
        class="filter-item"
        clearable
      >
        <el-option label="充值" :value="5" />
        <el-option label="提现" :value="2" />
        <el-option label="寄售卖出" :value="1" />
        <el-option label="寄售买入" :value="3" />
      </el-select>
      <el-button
        class="filter-item"
        type="primary"
        icon="el-icon-search"
        @click="handleFilter"
      >搜索</el-button
      >
      <span class="filter-item">
        <download-excel
          :fields="json_fields"
          :fetch="handleExport"
          type="xls"
          name="钱包流水信息.xls"
          worksheet="钱包流水信息"
        >
          <el-button type="success" :loading="exportLoading">
            导出流水信息
          </el-button>
        </download-excel>
      </span>
      <!--      <span class="filter-item">-->
      <!--        <download-excel-->
      <!--            :fields="json_fields"-->
      <!--            :fetch="handleExport"-->
      <!--            type="xls"-->
      <!--            name="寄卖订单信息.xls"-->
      <!--            worksheet="寄卖订单信息"-->

      <!--        >-->
      <!--&lt;!&ndash;      :before-generate="startPost"-->
      <!--          :before-finish="endPost"                :header="header"&ndash;&gt;-->
      <!--          <el-button type="warning" :loading="exportLoading">-->
      <!--            导出订单信息-->
      <!--          </el-button>-->
      <!--        </download-excel>-->
      <!--      </span>-->
    </div>
    <div class="filter-container">
      <!-- <el-radio-group v-model="listQuery.status" size="small" @change="handleFilter">
        <el-radio-button label="">全部</el-radio-button>
        <el-radio-button label="1">未匹配</el-radio-button>
        <el-radio-button label="2">待买家打款</el-radio-button>
        <el-radio-button label="3">已完成</el-radio-button>
        <el-radio-button label="4">已取消</el-radio-button>
      </el-radio-group> -->
    </div>

    <div style="margin-bottom:5px;display: flex;float:left;margin-left: 10px">卖出总额累计:{{list.total_sell_out_money}}</div>
    <div style="margin-bottom:5px;display: flex;float:left;margin-left: 30px">充值总额累计:{{list.total_recharge_money}}</div>
    <div style="margin-bottom:5px;display: flex;float:left;margin-left: 30px">提现总额累计:{{list.total_cash_out_money}}</div>
    <div style="margin-bottom:5px;display: flex;float:left;margin-left: 30px">寄售记录次数:{{list.total_sell_out_count}}</div>
    <el-table
      v-loading="listLoading"
      :data="list.data.data"
      element-loading-text="Loading"
      size="small"
      border
      fit
      highlight-current-row
    >
      <el-table-column align="center" label="序号" width="95">
        <template slot-scope="scope">
          {{ scope.$index + 1 }}
          <!-- {{ scope.row.id }} -->
        </template>
      </el-table-column>
      <el-table-column align="center" label="ID" width="95" v-if="false">
        <template slot-scope="scope">
          {{ scope.row.id }}
          <!-- {{ scope.row.id }} -->
        </template>
      </el-table-column>

      <el-table-column label="头像" min-width="60" align="center">
        <template slot-scope="scope">
          <img
            :src="scope.row.user ? scope.row.user.avatar : '#'"
            class="user-avatar"
          />
        </template>
      </el-table-column>
      <el-table-column label="用户ID" min-width="80" align="center">
        <template slot-scope="scope">
          {{ scope.row.user_id }}
        </template>
      </el-table-column>
      <el-table-column label="手机号" min-width="80" align="center">
        <template slot-scope="scope">
          {{ scope.row.user.account }}
        </template>
      </el-table-column>
      <el-table-column label="昵称" min-width="80" align="center">
        <template slot-scope="scope">
          {{ scope.row.user ? scope.row.user.nickname : "-" }}
        </template>
      </el-table-column>

      <el-table-column label="收支类型" min-width="80" align="center">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.is_payout === 0" type="success"> 收入</el-tag>
          <el-tag v-else-if="scope.row.is_payout === 1" type="warning">支出</el-tag>
        </template>
      </el-table-column>

      <el-table-column label="金额" min-width="80" align="center">
        <template slot-scope="scope">
          {{ scope.row.money }}
        </template>
      </el-table-column>

      <el-table-column label="收支操作" min-width="80" align="center">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.type === 1" type="success">卖出{{scope.row.remark ? scope.row.remark : '' }}</el-tag>
          <el-tag v-else-if="scope.row.type === 2" type="warning">提现支出</el-tag>
          <el-tag v-else-if="scope.row.type === 3" type="warning">购买{{scope.row.remark ? scope.row.remark : '' }}</el-tag>
          <el-tag v-else-if="scope.row.type === 4" :type="scope.row.remark === '后台充值'? 'success' : 'warning'">{{scope.row.remark ? scope.row.remark : '' }}</el-tag>
          <el-tag v-else-if="scope.row.type === 5" type="success">{{scope.row.remark ? scope.row.remark : '' }}</el-tag>
          <el-tag v-else-if="scope.row.type === 7" type="success">{{scope.row.remark ? scope.row.remark : '' }}</el-tag>
        </template>
      </el-table-column>

      <el-table-column label="操作前余额" min-width="80" align="center">
        <template slot-scope="scope">
          {{ scope.row.before_balance }}
        </template>
      </el-table-column>

      <el-table-column label="操作后余额" min-width="80" align="center">
        <template slot-scope="scope">
          {{ scope.row.after_balance }}
        </template>
      </el-table-column>


      <el-table-column label="创建时间" min-width="80" align="center">
        <template slot-scope="scope">
          {{ scope.row.created_at }}
        </template>
      </el-table-column>

      <el-table-column label="更新时间" min-width="80" align="center">
        <template slot-scope="scope">
          {{ scope.row.updated_at }}
        </template>
      </el-table-column>

      <!--      <el-table-column label="操作" align="center" width="120" fixed="right">-->
      <!--        <template slot-scope="scope">-->
      <!--          <el-button size="mini" type="warning" @click="handleExit(scope.row)" ></el-button>-->
      <!--        </template>-->
      <!--      </el-table-column>-->
    </el-table>

    <div class="pagination-container">
      <el-pagination
        :current-page="listQuery.page"
        :page-sizes="[10, 20, 30, 50, 100]"
        :page-size="listQuery.limit"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>

<script>
import request from "@/utils/request";
import downloadExcel from "vue-json-excel";
export default {
  components: { downloadExcel },
  data() {
    return {
      list: null,
      total: 0,
      listLoading: true,
      listQuery: {
        page: 1,
        limit: 10,
        user_id: "",
        phone: "",
        is_payout:"",
        type:""
      },
      dialogFormVisible: false,
      btnLoading: false,
      exportLoading: false,
      form: {},
      dateArr: null,
      //导出
      json_fields: {
        用户ID: {
          field: "user_id",
          //自定义回调函数
          callback: (value) => {
            return "<p style=\"mso-number-format:'\\@';\">" + value + "</p>";
          },
        },
        手机号: {
          field: "user.account",
          //自定义回调函数
          callback: (value) => {
            return "<p style=\"mso-number-format:'\\@';\">" + value + "</p>";
          },
        },
        昵称: "user.nickname",
        收支类型: {
          field: "type",
          //自定义回调函数
          callback: (value) => {
            if (value == 1) {
              return "支出";
            }else {
              return "收入";
            }
          },
        },
        金额: {
          field: "money",
          //自定义回调函数
          callback: (value) => {
            return "<p style=\"mso-number-format:'\\@';\">" + value + "</p>";
          },
        },
        收支操作: "remark",
        // 收支操作: {
        //   field: "remark",
        //   //自定义回调函数
        //   callback: (value) => {
        //     if (value == 1) {
        //       return "卖出";
        //     } else if (value == 2) {
        //       return "支出";
        //     } else if (value == 3) {
        //       return "支出";
        //     } else if (value == 4) {
        //       return "支出";
        //     } else if (value == 5) {
        //       return "支出";
        //     }
        //   },
        // },
        操作前余额: {
          field: "before_balance",
          //自定义回调函数
          callback: (value) => {
            return "<p style=\"mso-number-format:'\\@';\">" + value + "</p>";
          },
        },
        操作后余额: {
          field: "after_balance",
          //自定义回调函数
          callback: (value) => {
            return "<p style=\"mso-number-format:'\\@';\">" + value + "</p>";
          },
        },
        创建时间: {
          field: "created_at",
          //自定义回调函数
          callback: (value) => {
            return "<p style=\"mso-number-format:'\\@';\">" + value + "</p>";
          },
        },
      },
    };
  },
  created() {
    if(this.$route.query.account != "undefined") {
      this.listQuery.phone = this.$route.query.account;
      this.getList();
    }
    this.getList();
  },
  watch: {
    dateArr(newVal, oldVal) {
      if (newVal) {
        this.listQuery.start_at = newVal[0];
        this.listQuery.end_at = newVal[1];
      } else {
        this.listQuery.start_at = "";
        this.listQuery.end_at = "";
      }
    },
  },
  methods: {
    // handleExport() {
    //   this.exportLoading=true;
    //   var query =JSON.parse(JSON.stringify(this.listQuery))  ;
    //   query.limit = 99999999999999;
    //   return request({
    //     url: "/api/backend/consignment/walletList",
    //     method: "post",
    //     params: query,
    //   })
    //       .then((result) => {
    //         var json_data = result.data.data;
    //         this.header = "寄卖订单信息";
    //         return json_data;
    //       })
    //       .catch((err) => {
    //         console.log(err);
    //       })
    //       .finally(() => {
    //         this.listLoading = false;
    //         this.exportLoading=false;
    //       });
    // },
    handleExport() {
      this.exportLoading = true;
      var query = JSON.parse(JSON.stringify(this.listQuery));
      query.limit = 99999999999999;
      return request({
        url: "/api/backend/consignment/walletLogList",
        method: "post",
        params: query,
      })
        .then((result) => {
          var json_data = result.data.data.data;
          this.header = "钱包流水信息";
          return json_data;
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.listLoading = false;
          this.exportLoading = false;
        });
    },
    getList() {
      this.listLoading = true;
      request({
        url: "/api/backend/consignment/walletLogList",
        method: "post",
        params: this.listQuery,
      }).then((response) => {
        this.list = response.data;
        this.total = response.data.data.total;
        this.listLoading = false;
        console.log(this.list);
      });
    },
    handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    handleEdit(object) {
      this.form = JSON.parse(JSON.stringify(object));
      this.dialogFormVisible = true;
    },

    // saveData() {
    //   this.btnLoading = true;
    //   request({
    //     url: "/api/backend/task/save",
    //     method: "post",
    //     data: this.form,
    //   })
    //     .then((response) => {
    //       this.btnLoading = false;
    //       this.dialogFormVisible = false;
    //       this.$notify({
    //         title: "成功",
    //         message: "保存成功",
    //         type: "success",
    //         duration: 2000,
    //       });
    //       this.getList();
    //     })
    //     .catch((err) => {
    //       this.btnLoading = false;
    //     });
    // },
  },
};
</script>


<style rel="stylesheet/scss" lang="scss" scoped>
.user-avatar {
  width: 40px;
  height: 40px;
  border-radius: 6px;
}
</style>

